
:host {
  display: block;
  width: 50%;
  height: 25%;
}
